import { Trans } from '@lingui/react/macro';
import { NoddiButton, NoddiDummyButton } from 'noddi-ui-web';

export const SalesItemButtons = ({
  isUnavailable,
  isTemporarilyUnavailable,
  isLocked,
  description,
  isSelected,
  onShowFullDescriptionClick,
  onTemporarilyUnavailableClick
}: {
  isUnavailable?: boolean;
  isTemporarilyUnavailable?: boolean;
  isLocked?: boolean;
  description: string;
  isSelected: boolean;
  onShowFullDescriptionClick: (event: React.MouseEvent<HTMLButtonElement>) => void;
  onTemporarilyUnavailableClick?: (event: React.MouseEvent<HTMLButtonElement>) => void;
}) => {
  if (isTemporarilyUnavailable) {
    return (
      // eslint-disable-next-line noddi/no-emoji-in-ui -- deliberate glyph inside a customer-facing copy string, where a NoddiIcon element cannot be embedded
      <NoddiButton className='-mr-3' size='small' variant='link' onClick={onTemporarilyUnavailableClick}>
        ⚠️ <Trans>This service is temporarily unavailable</Trans>
      </NoddiButton>
    );
  }

  if (isUnavailable) {
    return (
      <NoddiDummyButton startIcon='SquareArrowOutUpRight' className='-mr-3' size='small' variant='link'>
        <Trans>Why am I not able to select this?</Trans>
      </NoddiDummyButton>
    );
  }

  return (
    <div className='flex items-center gap-2'>
      {!!description && (
        <NoddiButton
          startIcon='SquareArrowOutUpRight'
          size='small'
          variant={isSelected ? 'lightLink' : 'link'}
          onClick={onShowFullDescriptionClick}
        >
          <Trans>Details</Trans>
        </NoddiButton>
      )}
      <NoddiDummyButton variant='outline' startIcon={isLocked ? 'Lock' : isSelected ? 'Minus' : 'Plus'} size='small'>
        {isLocked ? <Trans>Included</Trans> : isSelected ? <Trans>Remove</Trans> : <Trans>Add</Trans>}
      </NoddiDummyButton>
    </div>
  );
};
